export function getIsRatCoreEventsOnly(ratCoreEventsOnly: string | undefined) {
	let isRatCoreEventsOnly = false;
	if (
		typeof ratCoreEventsOnly !== 'undefined' &&
		ratCoreEventsOnly !== 'false'
	) {
		isRatCoreEventsOnly = true;
	}

	return isRatCoreEventsOnly;
}
